import { ItemList } from "../orm"

class CustomerPromotionalMediaList extends ItemList {
  getEntityKey() {
    return "customer/promotional_media"
  }
}

export const customerPromotionalMediaList = new CustomerPromotionalMediaList(
  "customer_promotional_media__default"
)
